<template>
<div class="chapter">
<div class="inner_page">
<div>
<img alt="cover" height="100%" src="OEBPS/images/cover.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cvi.vue?456282c6